export default {
  teamnameUpdated: 'teamnameUpdated',
};



// WEBPACK FOOTER //
// ./src/constants/events.js